import React from "react";
import Badge from "./Badge.jsx";

function sevTone(sev) {
  const s = String(sev || "").toLowerCase();
  if (s === "critical") return "red";
  if (s === "high") return "orange";
  if (s === "medium") return "yellow";
  if (s === "low") return "blue";
  return "muted";
}

export default function FindingsTable({ items }) {
  if (!items?.length) {
    return <div className="muted">No findings to display.</div>;
  }

  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th style={{ width: 110 }}>Severity</th>
            <th style={{ width: 120 }}>Category</th>
            <th>Message</th>
            <th style={{ width: 360 }}>File</th>
            <th style={{ width: 80 }}>Line</th>
          </tr>
        </thead>
        <tbody>
          {items.map((r) => (
            <tr key={r.id}>
              <td>
                <Badge tone={sevTone(r.severity)}>{r.severity}</Badge>
              </td>
              <td className="mono small">{r.category}</td>
              <td>{r.message}</td>
              <td className="mono small">{r.file_path || "—"}</td>
              <td className="mono small">{r.line ?? "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
